<template>
  <div class="h-100 my-5">
    <b-button
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Cancel') }}
    </b-button>
    <div class="dp02 p-3 mt-3 row">
      <div class="text-center col-lg-12">
        <h2>{{ $t('CreateUser.Header') }}</h2>
      </div>
      <transition name="slide-fade-main"
                  mode="out-in"
                  appear>
        <ValidationObserver v-if="!created"
                            ref="observer"
                            v-slot="{invalid}"
                            tag="form"
                            class="col-lg-12 mt-5"
                            @submit.prevent="submit()">
          <div class="col-lg-12 row">
            <div class="col-lg-1 offset-lg-4">
              <label for="email">{{ $t('common.Email') }}</label>
            </div>
            <div class="col-lg-3">
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{errors, classes}">
                <b-form-input
                  id="email"
                  v-model="email"
                  :class="{...classes, myInput: true}" />
                <p class="myInputError mt-2">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-lg-12 row">
            <div class="col-lg-1 offset-lg-4">
              <label for="role">{{ $t('entities.Roles.Singular') }}</label>
            </div>
            <div class="col-lg-3">
              <v-multiselect
                ref="multiselect"
                v-model="role"
                label="name"
                track-by="id"
                :allow-empty="false"
                :preselect-first="true"
                :options="availableRoles" />
            </div>
          </div>
          <div class="col-lg-12 row mt-3">
            <div class="col-lg-1 offset-lg-4">
              <label for="color">{{ $t('common.Color') }}</label>
            </div>
            <div class="col-lg-3">
              <ColorInput v-model="color" />
            </div>
          </div>
          <div class="col-lg-12 row mt-3"
               v-if="role != null && (role.name === 'Lékař' || role.name === 'Doctor')">
            <div class="col-lg-1 offset-lg-4">
              <label for="color">{{ $t('common.IsMainDoctor') }}</label>
            </div>
            <div class="col-lg-3">
              <b-form-checkbox v-model="mainDoctor" />
            </div>
          </div>
          <div class="col-lg-12 text-center">
            <b-button
              class="mt-3 myButton align-middle"
              type="submit">
              {{ $t('CreateUser.CreateUser') }}
            </b-button>
            <b-spinner
              v-show="creating"
              variant="primary"
              class="align-middle ml-3"
              label="Spinning" />
          </div>
        </ValidationObserver>
        <div v-else
             class="col-lg-12 mt-5 text-center">
          <div class="col-lg-12">
            <h5>{{ $t('CreateUser.Success') }}</h5>
          </div>
          <div class="col-lg-4 offset-lg-4">
            <h6>{{ $t('common.Email') }}:</h6><p>{{ email }}</p>
            <h6>{{ $t('common.Password') }}:</h6><p>{{ password }}</p>
          </div>
          <div class="col-lg-12 text-center">
            <b-button class="mt-3 myButton align-middle"
                      @click="$router.go(-1)">
              {{ $t('CreateUser.BackToList') }}
            </b-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import ColorInput from '@components/input/ColorInput';

export default {
  name: 'CreateUser',
  components: {
    ColorInput
  },
  data() {
    return {
      email: '',
      creating: false,
      created: false,
      role: {},
      mainDoctor: false,
      color: 1
    };
  },
  computed: {
    ...mapState('createEditUser', ['password', 'availableRoles']),
  },
  watch: {
    email(val) {
      this.setEmail(val);
    },
    // eslint-disable-next-line func-names
    '$i18n.locale': function () {
      this.fetchRoles();
    },
    role(val) {
      this.setRole(val);
    },
    color(val) {
      this.setColor(val);
    },
    availableRoles(val) {
      [this.role] = val;
    },
    mainDoctor(val) {
      this.setMainDoctor(val);
    }
  },
  created() {
    this.resetContext();
  },
  mounted() {
    this.fetchRoles();
  },
  methods: {
    ...mapMutations({
      setEmail: 'createEditUser/setEmail',
      setPassword: 'createEditUser/setPassword',
      setRole: 'createEditUser/setRole',
      setColor: 'createEditUser/setColor',
      setMainDoctor: 'createEditUser/setMainDoctor'
    }),
    ...mapActions({ resetContext: 'createEditUser/resetContext', createUser: 'createEditUser/createUser', fetchRoles: 'createEditUser/fetchRoles' }),
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.creating = true;
        this.createUser().then((res) => {
          this.created = true;
          this.creating = false;
          this.setPassword(res.data.password);
        })
          .catch((err) => {
            if (err.status === 409) {
              this.creating = false;
              this.$refs.observer.setErrors({
                email: [this.$t('CreateUser.EmailNotUnique')]
              });
            }
          });
      }
    },

  }
};
</script>

<style lang="scss" scoped>
</style>
